import { useState, useEffect, useCallback } from "react";
import { postObject } from "../../services/trackerService";
import ConfirmScan from "../common/confirmscan/ConfirmScan";
import Header from "../common/header/Header";
import PopUp from "../common/popup/PopUp";
import QrScanner from "../common/scanner/QrScanner";

const LotScanner = () => {
    const url = window.location.href;
    const [step, setStep] = useState(1);
    const [badgeInput, setBadgeInput] = useState('');
    const [lotInput, setLotInput] = useState('');
    const [locationInput, setLocationInput] = useState('');
    const [containerInput, setContainerInput] = useState('');
    const [restInput, setRestInput] = useState(0);
    const [restConfirm, setRestConfirm] = useState(false);
    const [postResult, setPostResult] = useState(null);
    const [inputsSwitched, setInputsSwitched] = useState(false);
    const [validLocation, setValidLocation] = useState(false);

    const postResults = useCallback(async () => {
        const key = badgeInput.split("=")[1];
        const object = {
            Badge: badgeInput + '$' + (new Date()).toLocaleString().replaceAll('-', '/'),
            Lot: lotInput,
            Location: locationInput
        };
        const result = await postObject('/scan', object, key, true);
        setPostResult(result);
    }, [badgeInput, lotInput, locationInput]);

    const postRest = useCallback(async () => {
        const key = badgeInput.split("=")[1];
        const object = {
            LotString: lotInput,
            Rest: restInput
        };
        const result = await postObject('/lot/rest', object, key, true);
        console.log(result);
        setPostResult(result);
        setRestConfirm(false);
    }, [badgeInput, lotInput, restInput]);

    const postContainer = useCallback(async () => {
        const key = badgeInput.split("=")[1];
        const object = {
            Badge: badgeInput + '$' + (new Date()).toLocaleString().replaceAll('-', '/'),
            Container: lotInput,
        }
        const result = await postObject('/waste/container', object, key, true);
        setPostResult(result)
    }, [badgeInput, lotInput]);

    const CheckUrl = useCallback(() => {
        const splittedUrl = url.split('#');
        if (splittedUrl.length === 2 && splittedUrl[0].includes('=') && step === 1 && !(postResult && postResult.status && (postResult.status === 201 || postResult.status === 200))) {
            setBadgeInput(splittedUrl[0]);
            setStep(2);
        }
    }, [url, step, postResult]);

    const checkLocation = useCallback(() => {
        if (!((locationInput.split('$').length === 2 && locationInput.toLowerCase().includes('bin')) || locationInput.split('$').length !== 2)) {
            setValidLocation(true);
            setInputsSwitched(false);
        }
    }, [locationInput]);

    useEffect(() => {
        CheckUrl();
        if (step === 6) {
            checkLocation();
        }
        if (restInput > 0 && step === 7 && restConfirm) {
            postRest();
        } else if (validLocation && badgeInput !== '' && lotInput !== '' && locationInput !== '' && step === 7 && postResult === null) {
            postResults();
        } else if (badgeInput !== '' && containerInput !== '' && step === 7 && postResult === null) {
            postContainer();
        }
    }, [badgeInput, lotInput, locationInput, restInput, containerInput, step, restConfirm, postResult, validLocation, postResults, CheckUrl, postRest, postContainer, checkLocation]);

    const resetInputs = () => {
        setBadgeInput('');
        setLotInput('');
        setLocationInput('');
        setContainerInput('');
        setStep(1);
        setRestInput(0);
        setPostResult(null)
        setInputsSwitched(false);
    }

    const checkContainerScan = (text) => {
        switch (text.toLowerCase()) {
            case 'container$new': return 1;
            case 'container$out': return 2;
            default: return 0;
        }
    }

    const checkInputsSwitched = (text) => {
        if (text.split('$').length === 2 && !text.toLowerCase().includes('bin')) {
            setInputsSwitched(true);
            return true;
        }
        return false;
    }

    const handleScanError = (error) => {
        console.error(error.message);
    }

    const handleBadgeScan = (data) => {
        if (data !== null && data !== undefined) {
            setBadgeInput(data);
            setStep(2);
        }
    };

    const handleLotScan = (data) => {
        if (data !== null && data !== undefined) {
            if (checkContainerScan(data) === 1) {
                setContainerInput(data)
                setStep(6)
            } else if (checkContainerScan(data) === 2) {
                setContainerInput(data);
                setInputsSwitched(true);
                setStep(4);
            } else {
                if (checkInputsSwitched(data)) setLocationInput(data);
                else setLotInput(data);
                setStep(4);
            }
        }
    }

    const handleLocationScan = (data) => {
        if (data !== null && data !== undefined) {
            if (checkContainerScan(data)) setContainerInput(data);
            else if (inputsSwitched) setLotInput(data);
            else setLocationInput(data);
            setStep(6);
        }
    }

    const handleRest = (rest) => {
        setRestInput(rest);
    }

    const handleRestConfirm = () => {
        setRestConfirm(true);
    }

    const handleConfirm = (step) => {
        setStep(step + 1);
    }

    const handleRetry = (step) => {
        setStep(step - 1);
    }


    const render = (step) => {
        switch (step) {
            case 1: return <QrScanner handleScan={handleBadgeScan} handleError={handleScanError} step={'Scan Badge'} />;
            case 2: return <ConfirmScan value={badgeInput.split("=")[0]} handleConfirm={() => handleConfirm(step)} handleRetry={() => handleRetry(step)} />
            case 3: return <QrScanner handleScan={handleLotScan} handleError={handleScanError} step={'Scan Lot or Waste Bin'} />;
            case 4: return <ConfirmScan value={inputsSwitched? locationInput : lotInput} handleConfirm={() => handleConfirm(step)} handleRetry={() => handleRetry(step)} />
            case 5: return <QrScanner handleScan={handleLocationScan} handleError={handleScanError} step={'Scan Location or Waste Container'} />;
            case 6: return validLocation? 
                <ConfirmScan value={locationInput.length > 0 ? inputsSwitched? lotInput : locationInput : containerInput} handleConfirm={() => handleConfirm(step)} handleRetry={() => handleRetry(step)} /> :
                <ConfirmScan value="Incorrect location, please scan again" handleConfirm={() => handleRetry(step)} handleRetry={() => handleRetry(step)} />
            default: return <></>
        }

    }

    const renderPopUp = () => {
        if (postResult && postResult.status && postResult.status === 201) {
            return <PopUp message={'Registration completed'} success resetInputs={resetInputs} />;
        } else if (postResult && postResult.status && postResult.status === 200) {
            return <PopUp message={'Rest quantity required'} success resetInputs={resetInputs} handleRest={handleRest} handleRestConfirm={handleRestConfirm} />;
        } else if (postResult && postResult.code && postResult.code === 'ERR_NETWORK') {
            return <PopUp message={'Offline, make sure to sync when back online. (Happens automaticly when next scan is successfull)'} warning resetInputs={resetInputs} />;
        } else if (postResult) {
            return <PopUp message={`Something went wrong, please try again`} success={false} resetInputs={resetInputs} />;
        }
    }

    return (
        <div>
            <Header />
            {renderPopUp()}
            {render(step)}
        </div>
    )
};

export default LotScanner;